// import React, { useState, useEffect } from "react";
// import { getVideos } from "../api/videoApi";
// import { getImages } from "../api/imageApi";
// import { getPdfs } from "../api/pdfApi";
// import { getLinks } from "../api/linkApi";

// function Publications() {
//   const [videos, setVideos] = useState([]);
//   const [images, setImages] = useState([]);
//   const [pdfs, setPdfs] = useState([]);
//   const [links, setLinks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchMedia = async () => {
//       try {
//         console.log("🔵 Fetching publications media...");

//         const [videoData, imageData, pdfData, linkData] = await Promise.all([
//           // getVideos("?category=Publications"),
//           // getImages("?category=Publications"),
//           // getPdfs("?category=Publications"),
//           // getLinks("?category=Publications"),
//           getVideos("Publications"),
//         getImages("Publications"),
//         getPdfs("Publications"),
//         getLinks("Publications"),
//         ]);

//         console.log("🟢 Fetched media data:", { videoData, imageData, pdfData, linkData });

//         setVideos(videoData);
//         setImages(imageData);
//         setPdfs(pdfData);
//         setLinks(linkData);
//       } catch (err) {
//         console.error("❌ Error fetching publications media", err);
//         setError("Failed to load media.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMedia();
//   }, []);

//   if (loading) return <p>Loading publications...</p>;
//   if (error) return <p>{error}</p>;




//   return (
//     <div className="container mx-auto px-4 py-8">
//       {/* Main Title */}
//       <h1 className="text-3xl font-bold text-center mb-6">Publications</h1>

//       {/* Videos Section */}
//       {videos.length > 0 && (
//         <>
//           <h2 className="text-2xl font-semibold mb-4">Videos</h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {videos.map((video) => (
//               <div key={video._id} className="bg-white shadow-md rounded-lg p-4">
//                 <h3 className="text-lg font-semibold">{video.title}</h3>
//                 <video className="w-full rounded-md mt-2" controls>
//                   <source
//                     src={video.fileUrl ? `http://localhost:5555${video.fileUrl}` : video.url}
//                     type="video/mp4"
//                   />
//                   Your browser does not support the video tag.
//                 </video>
//               </div>
//             ))}
//           </div>
//         </>
//       )}

//       {/* Images Section */}
//       {images.length > 0 && (
//         <>
//           <h2 className="text-2xl font-semibold mt-8 mb-4">Images</h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {images.map((image) => (
//               <div key={image._id} className="bg-white shadow-md rounded-lg p-4">
//                 <h3 className="text-lg font-semibold">{image.title}</h3>
//                 {/* <img
//                   className="w-full rounded-md mt-2"
//                   src={image.fileUrl ? `http://localhost:5555${image.fileUrl}` : image.url}
//                   alt={image.title}
//                 /> */}
//                 <img
//                 className="w-full h-auto rounded-md mt-2 object-cover"
//                 src={image.imageUrl ? image.imageUrl.replace("_640", "_1280") : `http://localhost:5555${image.fileUrl}`}
//                 alt={image.title || "Uploaded Image"}
//                 onError={(e) => e.target.src = "/default-placeholder.png"} // Use a placeholder if image fails to load
//               />
//               </div>
//             ))}
//           </div>
//         </>
//       )}

//       {/* PDFs Section */}
//       {pdfs.length > 0 && (
//         <>
//           <h2 className="text-2xl font-semibold mt-8 mb-4">PDFs</h2>
//           <ul className="list-disc pl-5">
//             {pdfs.map((pdf) => (
//               <li key={pdf._id} className="mb-2">
//                 <a
//                   href={pdf.fileUrl ? `http://localhost:5555${pdf.fileUrl}` : pdf.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-500 hover:underline"
//                 >
//                   {pdf.title}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </>
//       )}

//       {/* External Links Section */}
//       {links.length > 0 && (
//         <>
//           <h2 className="text-2xl font-semibold mt-8 mb-4">External Links</h2>
//           <ul className="list-disc pl-5">
//             {links.map((link) => (
//               <li key={link._id} className="mb-2">
//                 <a
//                   href={link.url}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-500 hover:underline"
//                 >
//                   {link.title}
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </>
//       )}
//     </div>
//   );
// }

// export default Publications;

import React, { useState, useEffect } from 'react';
import { getVideos } from '../api/videoApi';
import { getImages } from '../api/imageApi';
import { getPdfs } from '../api/pdfApi';
import { getLinks } from '../api/linkApi';
import Footer from './Footer';

function Publications() {
  const [videos, setVideos] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // const [showAllPdfs, setShowAllPdfs] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        console.log("🔵 Fetching videos, images, and PDFs...");

        const [videoData, imageData, pdfData, linkResponse] = await Promise.all([
          getVideos("Publications"), getImages("Publications"), getPdfs("Publications"), getLinks("Publications")
        ]);

        console.log("🟢 API Response - Images:", imageData);
        console.log("🟢 API Response - Videos:", videoData);
        console.log("🟢 API Response - PDFs:", pdfData);
        console.log("🟢 API Response - Links:", linkResponse);

        setVideos(videoData);
        setImages(imageData);
        // setPdfs(pdfData);
        setPdfs(pdfData.sort((a, b) => new Date(b.date) - new Date(a.date)));

        setLinks(linkResponse);
      } catch (err) {
        console.error("❌ Error fetching media", err);
        setError("Failed to load media.");
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);

  if (loading) return <p className="text-center text-gray-600">Loading media...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  console.log("📄 Debug PDFs:", pdfs);

  // ✅ Show only the first 10 PDFs initially
  // const visiblePdfs = showAllPdfs ? pdfs : pdfs.slice(0, 10);

  const handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setSubmittedQuery(searchTerm.trim().toLowerCase()); // store normalized query
    setShowDropdown(false); // collapse view-more on new search
  };

  const query = (submittedQuery || "").trim().toLowerCase();
  const filteredPdfs = query
    ? pdfs.filter(p => (
      ((p.title || "") + " " + (p.pdfUrl || p.fileUrl || p.url || "")).toLowerCase()
    ).includes(query))
    : pdfs;


  return (
    <div className="flex flex-col min-h-screen">
      {/* Full-width Hero Image Section */}
      <div className="relative w-full">
        <img
          src="/Hero-Publications.jpeg"
          // className="w-full h-[70vh] object-cover"
          // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
          className="w-full h-auto object-cover object-center"
        />
        <div className="absolute inset-x-0 bottom-0 sm:bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
          <div className="bg-black bg-opacity-50 p-2 sm:p-6 rounded-lg inline-block">
            <h1 className="text-xl sm:text-5xl font-bold drop-shadow-lg">Publications</h1>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 flex-grow">
        {/* Page Title & Intro */}
        {/* <div className="text-center mb-12">
        <h1 className="text-5xl font-bold text-primary">Publications</h1>
        <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">
          Explore the latest publications from The Owen Lab.
        </p>
      </div> */}

        <h1 className="text-3xl font-bold text-center text-primary">Scientific Papers, Chapters and Books</h1>
        <p className="text-md text-black font-bold text-center mt-3 max-w-3xl mx-auto mb-6">
          Many of the lab’s scientific papers, chapters and books are available here in PDF format. Our most recent publications appear first. Scroll down for older publications. Please use your browser’s find/search function to locate a specific publication or author.
        </p>

        <form onSubmit={handleSearchSubmit} className="max-w-3xl mx-auto mb-8">
          <div className="flex items-center gap-3">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search publications"
              className="flex-1 rounded-full border border-primary py-3 px-4 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-300"
            />
            <button type="submit" className="inline-flex items-center px-5 py-2 rounded-full bg-sky-400 hover:bg-sky-500 text-primary font-medium shadow">
              Search
            </button>

            {submittedQuery && (
              <button type="button" onClick={() => { setSearchTerm(""); setSubmittedQuery(""); }} className="ml-2 text-sm text-gray-600 hover:underline">Clear</button>
            )}
          </div>
        </form>


        {/* Media Sections */}
        <div className="space-y-12">
          {/* Videos */}
          {/* <SectionCard title="Videos">
          {videos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((video) => (
                <MediaCard key={video._id} title={video.title}>
                  <video className="w-full rounded-md shadow-lg" controls>
                    <source src={video.fileUrl ? `http://localhost:5555${video.fileUrl}` : video.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </MediaCard>
              ))}
            </div>
          ) : (
            <NoContent text="No videos found." />
          )}
        </SectionCard> */}

          {/* Images */}
          {/* <SectionCard title="Images">
          {images.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {images.map((image) => (
                <MediaCard key={image._id} title={image.title}>
                  <img
                    className="w-full h-auto rounded-md mt-2 object-cover"
                    src={image.imageUrl} // ✅ This always holds the correct URL
                    alt={image.title || "Uploaded Image"}
                    onError={(e) => (e.target.src = "/default-placeholder.png")} // ✅ Fallback if image fails to load
                  />


                </MediaCard>
              ))}
            </div>
          ) : (
            <NoContent text="No images found." />
          )}
        </SectionCard> */}

          {/* PDFs */}
          {/* <SectionCard title="Publications">
          {pdfs.length > 0 ? (
            <ul className="space-y-2">
              
              {visiblePdfs.map((pdf) => (
              
                
                <li key={pdf._id}>
                  <button
                    onClick={() => {
                      console.log("Full PDF Item:", pdf);
                      console.log("Checking fileUrl:", pdf.fileUrl);
                      console.log("Checking url:", pdf.url);
                      console.log("📄 Full PDF Item:", pdf); // Debugging
                      let pdfLink = pdf.pdfUrl || pdf.fileUrl || pdf.url; // ✅ Use correct URL field

                      if (!pdfLink) {
                        alert("PDF link is missing.");
                        console.error("❌ No valid PDF URL found!", pdf);
                        return;
                      }

                      console.log("Initial PDF URL before processing:", pdfLink);

                      // ✅ Fix for uploaded PDFs (ensure proper URL format)
                      if (!pdfLink.startsWith("http")) {
                        // pdfLink = `http://localhost:5555${pdfLink}`;
                        pdfLink = `http://localhost:5555${pdfLink.replace(/^\/+/, '')}`;
                      }

                      console.log("📂 Final PDF URL:", pdfLink);
                      window.open(pdfLink, "_blank", "noopener,noreferrer");
                    }}
                    className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
                  >
                    {pdf.title || "Untitled PDF"}
                  </button>

                </li>


              ))}
            </ul>
          ) : (
            <NoContent text="No PDFs found." />
          )}

          
        {pdfs.length > 10 && (
          <button
            onClick={() => setShowAllPdfs((prev) => !prev)}
            className="mt-4 text-blue-600 hover:underline"
          >
            {showAllPdfs ? "Show Less" : "View More"}
          </button>
        )}
        </SectionCard> */}

          {/* <SectionCard title="Publications"> */}
          <SectionCard>
            {/* {pdfs.length > 0 ? ( */}
            {filteredPdfs.length > 0 ? (
              <>
                {/* ✅ Show only top 10 PDFs initially */}
                {/* <ul className="space-y-2"> */}
                <ul className="space-y-4 list-none p-0 m-0">
                  {/* {pdfs.slice(0, 10).map((pdf) => ( */}
                  {filteredPdfs.slice(0, 10).map((pdf) => (
                    <li
                      key={pdf._id}
                      className="bg-gray-50 rounded-xl border border-primary p-5 hover:shadow-md transition-shadow duration-200"
                    >
                      <a
                        href={pdf.pdfUrl || pdf.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline hover:text-secondary transition duration-300"
                      // className="block text-md md:text-lg font-semibold text-sky-800 leading-snug hover:underline"
                      >
                        {pdf.title || "Untitled PDF"}
                      </a>

                      <div className="mt-3">
                        <a
                          href={pdf.pdfUrl || pdf.fileUrl || pdf.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-sm font-medium text-sky-600 hover:underline"
                        >
                          Read <span className="ml-2">→</span>
                        </a>
                      </div>
                    </li>
                  ))}
                </ul>

                {/* ✅ View More - Scrollable Dropdown */}
                {/* {pdfs.length > 10 && ( */}
                {filteredPdfs.length > 10 && (
                  <div className="mt-4">
                    <button
                      onClick={() => setShowDropdown(!showDropdown)}
                      className="text-blue-600 hover:underline font-semibold"
                    >
                      {showDropdown ? "Show Less" : "View More"}
                    </button>

                    {/* ✅ Scrollable dropdown for extra PDFs */}
                    {showDropdown && (
                      // <div className="mt-2 border p-3 bg-gray-100 rounded-lg overflow-y-auto" style={{ maxHeight: "200px" }}>
                      <div className="mt-4 rounded-lg border border-sky-100 bg-sky-50 p-3" style={{ maxHeight: '320px', overflowY: 'auto' }}>
                        {/* <ul className="space-y-2"> */}
                        <ul className="space-y-3 list-none p-0 m-0">
                          {/* {pdfs.slice(10).map((pdf) => ( */}
                          {filteredPdfs.slice(10).map((pdf) => (
                            <li
                              key={pdf._id}
                              className="bg-gray-50 rounded-xl border border-primary p-5 hover:shadow-md transition-shadow duration-200"
                            >
                              <a
                                href={pdf.pdfUrl || pdf.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                // className="text-primary hover:underline hover:text-secondary transition duration-300"
                                className="text-primary hover:underline hover:text-secondary transition duration-300"
                              >
                                {pdf.title || "Untitled PDF"}
                              </a>

                              <div className="mt-2">
                                <a
                                  className="text-sm font-medium text-sky-600 hover:underline"
                                  href={pdf.pdfUrl || pdf.fileUrl || pdf.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Read →
                                </a>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <NoContent text="No PDFs found." />
            )}
          </SectionCard>



          {/* External Links */}
          {/* <SectionCard title="External Links">
          {links.length > 0 ? (
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link._id}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-700 hover:underline hover:text-purple-900 transition duration-300"
                  >
                    {link.title || "Untitled Link"}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <NoContent text="No external links found." />
          )}
        </SectionCard> */}

        </div>

      </div>
      <Footer isFullFooter={false} />
    </div>
  );
}

/* Section Wrapper */
const SectionCard = ({ title, children }) => (
  <section className="bg-white border border-gray-200 shadow-lg rounded-xl p-4 sm:p-6">
    <h2 className="text-3xl font-semibold text-gray-900 mb-4">{title}</h2>
    {children}
  </section>
);

/* Card for Media Items */
const MediaCard = ({ title, children }) => (
  <div className="bg-gray-50 rounded-lg p-4 border border-gray-300 shadow-md">
    <h3 className="text-lg font-medium text-gray-800 mb-2">{title}</h3>
    {children}
  </div>
);

/* Placeholder for Empty Sections */
const NoContent = ({ text }) => <p className="text-gray-500">{text}</p>;

export default Publications;


